import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { PurchaseOrderDeliveryAddressMergeData, PurchaseOrderDeliveryAddressMergeSchema, PurchaseOrderLinesMergeData, PurchaseOrderLinesMergeSchema, PurchaseOrderMergeData, PurchaseOrderMergeSchema, PurchaseOrderSupplierMergeData, PurchaseOrderSupplierMergeSchema } from '../data/purchase.order.merge.data';
import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { ContactMergeData, ContactMergeSchema } from '../data/contact.merge.data';
import { BasicSiteMergeData, BasicSiteMergeSchema } from '../data/basic.site.merge.data';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';
import { JobMergeData } from '../data/job.merge.data';

@MergeDataset({
    entity: ActivityEntityName.PurchaseOrder,
    dependsOn: [
        ActivityEntityName.Job,
    ]
})
export class PurchaseOrderMergeDataSet {
    @MergeSource({
        schema: PurchaseOrderMergeSchema
    })
    purchaseOrder?: PurchaseOrderMergeData;

    @MergeSource({
        schema: PurchaseOrderLinesMergeSchema
    })
    purchaseOrderLine?: PurchaseOrderLinesMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    purchaseOrderCompany: CompanyMergeData;

    @MergeSource({
        schema: PurchaseOrderDeliveryAddressMergeSchema
    })
    purchaseOrderDeliveryAddress: PurchaseOrderDeliveryAddressMergeData;

    @MergeSource({
        schema: PurchaseOrderSupplierMergeSchema
    })
    purchaseOrderSupplier: PurchaseOrderSupplierMergeData;

    @MergeSource({
        schema: ContactMergeSchema
    })
    purchaseOrderSupplierContact: ContactMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema,
        ignoreCustomFields: true,
    })
    purchaseOrderSupplierAddress: BasicSiteMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    purchaseOrderOwner: EmployeeMergeData;

    job: JobMergeData;

    // @MergeSource({
    //     schema: PurchaseOrderDeliveryAddressMergeSchema
    // })
    // purchaseOrderDeliveryAddress: PurchaseOrderDeliveryAddressMergeData;

    public theme: Entity;
}
